import { apiClient, createAuthHeaders } from '../api-client';

export type ByocAuthMethod = 'api_key' | 'oauth_pro_max';

export interface ByocStatus {
  connected: boolean;
  maskedKey: string | null;
  connectedAt: string | null;
  authMethod?: ByocAuthMethod;
  userEmail?: string | null;
}

export interface ByocResponse {
  success: boolean;
  message: string;
}

export interface AnthropicOAuthExchangeDto {
  code: string;
  codeVerifier: string;
  state?: string; // Part after # in the auth code (OpenCode pattern)
}

export const byocApi = {
  /**
   * Get BYOC connection status
   */
  async getStatus(token: string): Promise<ByocStatus> {
    const response = await apiClient.get('/api/workspaces/byoc', {
      headers: createAuthHeaders(token),
    });
    return response.data;
  },

  /**
   * Connect BYOC API key (manual entry)
   */
  async connect(token: string, apiKey: string): Promise<ByocResponse> {
    const response = await apiClient.post(
      '/api/workspaces/byoc',
      { apiKey },
      { headers: createAuthHeaders(token) }
    );
    return response.data;
  },

  /**
   * Exchange Anthropic OAuth code for tokens/API key
   */
  async exchangeAnthropicCode(
    token: string,
    data: AnthropicOAuthExchangeDto
  ): Promise<ByocResponse> {
    const response = await apiClient.post(
      '/api/workspaces/byoc/anthropic-oauth',
      data,
      { headers: createAuthHeaders(token) }
    );
    return response.data;
  },

  /**
   * Disconnect BYOC API key
   */
  async disconnect(token: string): Promise<ByocResponse> {
    const response = await apiClient.delete('/api/workspaces/byoc', {
      headers: createAuthHeaders(token),
    });
    return response.data;
  },
};
